import { render, staticRenderFns } from "./simOpenXc.vue?vue&type=template&id=8ac075fa&scoped=true&"
import script from "./simOpenXc.vue?vue&type=script&lang=js&"
export * from "./simOpenXc.vue?vue&type=script&lang=js&"
import style0 from "./simOpenXc.vue?vue&type=style&index=0&id=8ac075fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac075fa",
  null
  
)

export default component.exports